import { toast as sonnerToast } from 'sonner';

export function useToast() {
  return {
    toast: (props: {
      title?: string;
      description?: string;
      variant?: 'default' | 'destructive' | 'success' | 'warning';
      action?: {
        label: string;
        onClick: () => void;
      };
    }) => {
      const { title, description, variant = 'default', action } = props;

      const toastOptions = {
        description: description,
        action: action
          ? {
              label: action.label,
              onClick: action.onClick,
            }
          : undefined,
      };

      switch (variant) {
        case 'destructive':
          return sonnerToast.error(title || 'Error', toastOptions);
        case 'success':
          return sonnerToast.success(title || 'Success', toastOptions);
        case 'warning':
          return sonnerToast.warning(title || 'Warning', toastOptions);
        default:
          return sonnerToast(title || 'Notification', toastOptions);
      }
    },
  };
}
